import React, { createContext, useContext, useState, useEffect } from 'react';
const AuthContext = createContext();
const USERS_KEY = 'lf_users';
const USER_KEY  = 'lf_user';

const DEFAULT_USERS = [
  { id:1, nombre:'Administrador', email:'LadyFons', password:'GalaxyS25', rol:'admin' },
  { id:2, nombre:'Rosy Guardado', email:'rosy', password:'rosy123', rol:'asesor' },
];

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const stored = JSON.parse(localStorage.getItem(USERS_KEY) || 'null');
    setUsers(stored || DEFAULT_USERS);
    const u = JSON.parse(localStorage.getItem(USER_KEY) || 'null');
    if (u) setUser(u);
    setLoading(false);
  }, []);

  const login = (email, password) => {
    const found = users.find(u => u.email === email && u.password === password);
    if (!found) return false;
    setUser(found);
    localStorage.setItem(USER_KEY, JSON.stringify(found));
    return true;
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem(USER_KEY);
  };

  return (
    <AuthContext.Provider value={{ user, users, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}
export const useAuth = () => useContext(AuthContext);
